import { E_ProcessEnv, getProcessEnv } from '../base/env'
import { reportError, reportWarn } from '../owl'
import knbUse from './knb-use'

export function knbCaptrue(config: {}, success: Function, fail: Function) {
  const sceneToken = getProcessEnv(E_ProcessEnv.VUE_APP_SCENE_TOKEN_STORAGE_WRITE)
  if (!sceneToken) {
    reportError({
      name: '截屏 sceneToken 必传',
    })
  }
  knbUse('capture', {
    sceneToken,
    returnType: 'localId',
    ...config,
    success(data: {}) {
      if (typeof success === 'function') {
        success(data)
      } else {
        window.$toasted.show('保存成功')
      }
    },
    fail(error: { errorCode: number }) {
      window.$toasted.show('保存失败[' + error.errorCode + ']')
      if (typeof fail === 'function') {
        fail()
      }
      reportWarn({
        name: 'KNB capture 失败' + error.errorCode,
        msg: error,
        global: true,
      })
    },
  })
}
